import { create } from 'zustand';

interface MisdirectedDetailState {
  open: boolean;
  sessionId: string | null;
  openDrawer: (sessionId: string) => void;
  closeDrawer: () => void;
}

export const useMisdirectedDetailStore = create<MisdirectedDetailState>(
  (set) => ({
    open: false,
    sessionId: null,
    openDrawer: (sessionId) => set({ open: true, sessionId }),
    closeDrawer: () => set({ open: false, sessionId: null }),
  })
);
